module.exports = __webpack_public_path__ + "static/media/arrow-right-white.b9099fbd.svg";